module.exports = __webpack_public_path__ + "static/media/OrderSummaryScreen.e9607ced.png";